module.exports = __webpack_public_path__ + "img/bill.ce28c7d8.svg";